import { ShieldCheck, Download, Cpu } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const POINTS = [
  { Icon: ShieldCheck, title: "100 % privé et gratuit", text: "L'IA tourne sur votre ordinateur. Vos questions ne sont jamais envoyées à un serveur, et c'est gratuit." },
  { Icon: Download, title: "Un téléchargement au premier lancement", text: "Le modèle (0,9 à 2,5 Go) est téléchargé une seule fois puis gardé dans votre navigateur. Les fois suivantes, il démarre en quelques secondes." },
  { Icon: Cpu, title: "Utilise votre carte graphique", text: "Grâce à WebGPU, le navigateur se sert de votre GPU. Sans carte graphique dédiée, choisissez un modèle léger." },
];

const FAQ = [
  { q: "Quel navigateur utiliser ?", a: "Google Chrome ou Microsoft Edge (version 113 ou plus récente) sur ordinateur : c'est le plus fiable. Safari récent (macOS 26 / iOS 26) et Firefox récent sur Windows peuvent aussi fonctionner. Mettez votre navigateur à jour en cas de problème." },
  { q: "« WebGPU indisponible » : que faire ?", a: "1. Mettez à jour Chrome ou Edge. 2. Ouvrez chrome://gpu (ou edge://gpu) et vérifiez que « WebGPU » est activé. 3. Activez l'accélération matérielle dans les paramètres du navigateur (Système › Utiliser l'accélération graphique). 4. Mettez à jour les pilotes de votre carte graphique. 5. Redémarrez le navigateur." },
  { q: "Quel modèle choisir ?", a: "Qwen 2.5 1.5B convient à la plupart des ordinateurs. Ordinateur ancien ou sans GPU : Qwen 0.5B ou Llama 3.2 1B. Bonne carte graphique (4 Go de VRAM ou plus) : Qwen 2.5 3B pour de meilleures réponses." },
  { q: "Le téléchargement est lent ou bloqué", a: "Restez sur la page pendant le téléchargement et utilisez une connexion stable (Wi-Fi). S'il est interrompu, relancez : la partie déjà téléchargée est conservée." },
  { q: "Les réponses sont lentes ou l'onglet se fige", a: "Fermez les autres onglets et applications gourmandes, ou passez à un modèle plus léger. Les petits modèles sont moins précis qu'une grande IA en ligne : vérifiez les informations importantes." },
  { q: "Comment libérer de l'espace disque ?", a: "Utilisez le bouton « Supprimer du navigateur » à côté du modèle. Vous pouvez aussi effacer les données du site dans les paramètres du navigateur." },
];

export function LocalAiGuide() {
  return (
    <div className="space-y-4" data-testid="local-ai-guide">
      <div className="grid gap-3 sm:grid-cols-3">
        {POINTS.map(({ Icon, title, text }) => (
          <div key={title} className="rounded-lg border border-[#1E2638] bg-[#080B10] p-3">
            <Icon className="mb-1.5 h-4 w-4 text-primary" />
            <div className="text-sm font-medium text-slate-200">{title}</div>
            <p className="mt-1 text-xs text-muted-foreground">{text}</p>
          </div>
        ))}
      </div>
      <Accordion type="single" collapsible className="rounded-lg border border-[#1E2638] bg-[#080B10] px-3">
        {FAQ.map((f, i) => (
          <AccordionItem key={f.q} value={`q${i}`} className="border-[#1E2638]">
            <AccordionTrigger data-testid={`local-ai-faq-${i}`} className="text-sm hover:no-underline">{f.q}</AccordionTrigger>
            <AccordionContent className="text-xs text-muted-foreground">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
